import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {PaymentType} from '../../model/Entities/PaymentType';
import {ProductService} from '../../services/product.service';
import {Contract} from '../../model/Entities/Contract';
import {Observable} from 'rxjs/Observable';
import {CustomerService} from '../../services/customer.service';
import {ContractService} from '../../services/contract.service';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {ContractState} from '../../model/Entities/ContractState';
import {BarcodeService} from '../../services/barcode.service';
import {ContractItemService} from '../../services/contract-item.service';
import {ContractItemsTransferDialogComponent} from '../ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {AvailabilityService} from '../../services/availability.service';
import {ContractMailDialogComponent} from '../ContractMailDialogComponent/contract-mail.dialog.component';
import {PrintService} from '../../services/print.service';
import {ContractItemsListComponent} from '../ContractItemsListComponent/contract-items-list.component';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {ContractStateChangeConfirmDialogComponent} from '../ContractStateChangeConfirmDialogComponent/contract-state-change-confirm.dialog.component';
import {Filter} from '../../model/Helpers/Filter';
import {Transport} from '../../model/Entities/Transport';
import {TransportService} from '../../services/transport.service';
import {DocumentCreateDialogComponent} from '../../DocumentsModule/DocumentCreateDialogComponent/document-create.dialog.component';
import {EshopHideConfirmDialogComponent} from '../../DashboardModule/DashboardComponent/EshopHideConfirmDialogComponent/eshop-hide-confirm.dialog.component';
import {ContractConfirmMissingTransportDialogComponent} from '../ContractConfirmMissingTransportDialogComponent/contract-confirm-missing-transport.dialog.component';

@Component({
    selector: 'contract-detail',
    templateUrl: './contract-detail.component.html',
    styleUrls: ['./contract-detail.component.scss']
})
export class ContractDetailComponent implements OnInit {
    readonly contractStateClass: any = ContractState;

    contract: Contract = new Contract();
    paymentType: any = PaymentType;
    transports: Transport[];

    @ViewChild('itemsListComponent') itemsListComponent: ContractItemsListComponent;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private contractService: ContractService,
                private contractItemService: ContractItemService,
                private productService: ProductService,
                private customerService: CustomerService,
                private contactPersonService: CustomerContactPersonService,
                private availabilityService: AvailabilityService,
                private transportService: TransportService,
                private snackService: SnackService,
                private dialogService: DialogService,
                public printService: PrintService,
                public barcodeService: BarcodeService,
                private cdr: ChangeDetectorRef) {

    }

    ngOnInit(): void {
        const id = +this.route.snapshot.paramMap.get('id');
        this.contract = new Contract();

        this.loadContract(id);
    }

    public confirmContract(): void {
        const missingDelivery = this.contract.delivery && (!this.transports || !this.transports.some(t => t.type === 'in'));
        const missingBackDelivery = this.contract.backDelivery && (!this.transports || !this.transports.some(t => t.type === 'out'));

        if (missingDelivery || missingBackDelivery) {
            this.dialogService.showDialog(ContractConfirmMissingTransportDialogComponent, {
                missingDelivery,
                missingBackDelivery
            }).afterClosed().subscribe((result: boolean) => {
                if (result) {
                    this.performConfirmContract();
                }
            });
        } else {
            this.performConfirmContract();
        }
    }

    private performConfirmContract(): void {
        this.contract.state = ContractState.confirmed;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla potvrzena`);
        });
    }

    confirmHandled() {
        this.contract.state = ContractState.handed;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla předaná`);
        });
    }

    confirmPicked() {
        this.contract.state = ContractState.picked;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla vyzvednuta`);
        });
    }

    public confirmManualContract(): void {
        this.contract.manualApproved = true;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Manuální zápůjčka č. ${this.contract.id} byla schválena`);
        });
    }

    public dispatchContract(): void {

        if (this.contract.hasNonDispatchedItems()) {
            this.dialogService.showDialog(ContractStateChangeConfirmDialogComponent, {
                'direction': ContractItemTransfer.OUT
            }).afterClosed().subscribe((result: any) => {
                // console.log('DIALOG RESULT', result);
                if (result) {
                    this.performDispatchContract();
                    // console.log('DIspatch po dialogu');
                }
            });
        } else {
            if (!this.contract.delivery) {
                this.performDispatchContract();
            } else {
                this.preformPreparedContract();
            }
            // console.log('DISPATCH PRIMO');
        }
    }

    private performDispatchContract(): void {
        this.contract.state = ContractState.dispatched;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla vydána`);
        });
    }

    public returnContract(): void {

        if (this.contract.hasNonReturnedItems()) {
            this.dialogService.showDialog(ContractStateChangeConfirmDialogComponent, {
                'direction': ContractItemTransfer.IN
            }).afterClosed().subscribe((result: any) => {
                // console.log('DIALOG RESULT', result);
                if (result) {
                    this.performReturnContract();
                    // console.log('RETURN po dialogu');
                }
            });
        } else {
            this.performReturnContract();
            // console.log('RETURN PRIMO');
        }
    }

    private loadTransport(): void {
        this.transportService.getSimpleList([
            new Filter('contract_id', this.contract.id)
        ], { expand: 'users' }).subscribe((transports: Transport[]) => {
            this.transports = transports;
        })
    }

    private performReturnContract(): void {
        this.contract.state = ContractState.returned;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla vrácena`);
        });
    }

    public openTransferDialog(direction: any): void {
        this.dialogService.showDialog(ContractItemsTransferDialogComponent, {
            'contract': this.contract,
            'direction': direction
        }, 1000).afterClosed().subscribe((result: any) => {
            // console.log('TRANSFER DIALOG RESULT', result);
            this.itemsListComponent.loadContractItems(this.contract.id);
        });
    }

    public cloneContract(): void {
        this.contractService.clone(this.contract.id).subscribe((newContract: Contract) => {
            this.snackService.showSuccess(`Kopie zápůjčky byla vytvořena`);
            this.router.navigate([`/contract/${newContract.id}/edit`]);
        });
    }

    public emailContract(): void {
        this.dialogService.showDialog(ContractMailDialogComponent, {
            contract: this.contract
        }, 800).afterClosed().subscribe((result) => {
            if (result) {
                // alert('TODO mailing');

            }
        });
    }

    private loadContract(id: Number): void {
        // console.log('LOAC', id);
        this.contractService.get(id, {expand: 'customer,event'}).subscribe((c: Contract) => {
            // console.log('RESPONSE', c);
            this.contract = c;
            this.cdr.detectChanges();
            this.loadTransport();
        });
    }

    private updateContract(): Observable<Contract> {
        return this.contractService.update(this.contract.id, this.contract);
    }

    private preformPreparedContract() {
        this.contract.state = ContractState.prepared;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla připravena`);
        });
    }

    setDispatched() {
        this.contract.state = ContractState.dispatched;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla vydaná`);
        });
    }

    createDocument() {
        this.dialogService.showDialog(DocumentCreateDialogComponent, { contract: this.contract }).afterClosed().subscribe((r) => { console.log(r); });
    }

    setWaitingAccept() {
        this.contract.state = ContractState.waitingAccept;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} čeká na přijetí`);
        });
    }

    setReceived() {
        this.contract.state = ContractState.received;
        this.updateContract().subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla přijata`);
        });
    }

    hide(): void {
        this.dialogService.showDialog(EshopHideConfirmDialogComponent, {
            'contract': this.contract,
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.contractService.update(this.contract.id, { hide: true }).subscribe((c: Contract) => {
                    this.contract.hide = true;
                    this.snackService.showSuccess(`Zápůjčka ${this.contract.id} byla skryta z úvodní stránky`);
                });
            }
        });
    }

    unhide(): void {
        this.contractService.update(this.contract.id, { hide: false }).subscribe((c: Contract) => {
            this.contract.hide = false;
            this.snackService.showSuccess(`Zápůjčka ${this.contract.id} byla zobrazena na úvodní stránce`);
        });
    }

    isContractLongerThanWeek(): boolean {
        const from = new Date(this.contract.fromStart);
        const to = new Date(this.contract.toStart);
        const diffMs = to.getTime() - from.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        return diffDays > 7;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractDetailComponent/contract-detail.component.ts